import gql from 'graphql-tag';
import FieldsTransaction from 'graphql/fields/FieldsTransaction';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'transaction_guid': 'String!',
}

export default gql(`
	mutation transaction_payment( ${ HelperGraphql.createFields( fields ) } ) {
	    transaction_payment( ${ HelperGraphql.createVariables( fields ) } ) {
			${ FieldsTransaction }
	    }
	}
`);

